import { useMutation } from "react-query";
import api from "../../client";
import { CreateContextPayload } from "../../types/context";

const postData = async (payload: CreateContextPayload): Promise<any> => {
  const { data } = await api.post(`/context`, payload);

  return data;
};

export const useCreateContext = () => {
  return useMutation((payload: CreateContextPayload) => {
    return postData(payload);
  });
};
